export const QA_NAME_USER_INVITATION_MODAL = 'editInhabitantInvitation'
